<template>
  <div>
    <div class="slider-title">
      Projekt {{ item.projectCode }}
      <div class="close-panel" @click="$emit('closePanel')"><i class="fal fa-times close-icon"></i></div>
    </div>

    <div class="content slider-modal">
      <ul class="context-icons ">
        <li v-if="isInvoicePage(false)" @click="openFileViewerModal"><i class="fal fa-folder"></i><span class="is-vcentered">Mapp</span></li>
        <li v-if="isInvoicePage(true)" @click="openInvoicePreviewModal"><i class="fal fa-search"></i><span class="is-vcentered">Granska</span></li>
        <li @click="openCustomerModal"><i class="fal fa-building"></i><span>Kund</span></li>

        <li @click="openProjectModal"><i class="fal fa-edit"></i><span>Projekt</span></li>
        <li @click="openPriceListProjectModal"><i class="fal fa-list"></i><span>Prislista</span></li>

        <!-- <li v-if="!item.workOrderId" @click="openProjectModal"><i class="fal fa-edit"></i><span>Projekt</span></li> -->

        <!--  <li @click="pushToProjectDetails"><i class="fal fa-sitemap"></i><span>Projekt</span></li> -->
        <li @click="pushToContactRoute"><i class="fal fa-id-card"></i><span>Personer</span></li>
        <li @click="pushToAddressRoute"><i class="fal fa-map-marked-alt"></i><span>Adresser</span></li>
        <li @click="pushToWorkOrders"><i class="fal fa-boxes"></i><span>Insatser</span></li>
        <!-- <li @click="openWorkOrderModal"><i class="fal fa-box"></i><span>Skapa Insats</span></li> -->
        <!-- <li><i class="fal fa-boxes"></i><span>Leverans</span></li> -->
        <li v-if="isInvoicePage(false)" @click="openWorkOrderModal"><i class="fal fa-check-square"></i><span>Registrera</span></li>

        <!--<li v-if="isInvoicePage(false)" @click="pushToInvoices"><i class="fal fa-file-invoice-dollar"></i><span>Fakturera</span></li>-->
        <li v-if="isInvoicePage(false)" @click="openInvoicePreviewModal"><i class="fal fa-file-invoice-dollar"></i><span>Fakturera</span></li>

        <li @click="openProjectLogModal"><i class="fal fa-pen" ></i><span>Logg</span></li>
      </ul>
      <!-- <button class="button is-large" @click="$emit('closePanel')">Stäng</button> -->
    </div>
  </div>
</template>

<script>
import ProjectLogModal from '@/components/modals/ProjectLogModal'
import ProjectModal from '@/components/modals/ProjectModal'
import FileViewerModal from '@/components/modals/FileViewerModal'
import WorkOrderModal from '@/components/modals/WorkOrderModal'
import CustomerModal from '@/components/modals/CustomerModal'
import InvoicePreviewModal from '@/components/modals/InvoicePreviewModal'
import PriceListProjectModal from '@/components/modals/PriceListProjectModal'

export default {
  name: 'context-menu-modal',
  data () {
    return {
    }
  },

  components: {
    ProjectLogModal,
    FileViewerModal
  },

  props: {
    item: Object
  },

  computed: {
  },

  methods: {
    isInvoicePage (bool) {
      return !bool
      /*
      We are using the same context menu everywhere now - comment: why?
      if (bool) {
        return this.$route.name === 'Invoices' || this.$route.name === 'Invoices_Project'
      }
      return this.$route.name !== 'Invoices' && this.$route.name !== 'Invoices_Project'
      */
    },

    openProjectLogModal () {
      this.$panel(ProjectLogModal, { id: this.item.projectId })
    },

    openProjectModal () {
      this.$panel(ProjectModal, { id: this.item.projectId })
    },

    openCustomerModal () {
      this.$panel(CustomerModal, { id: this.item.customerId })
    },

    openPriceListProjectModal () {
      this.$panel(PriceListProjectModal, { projectId: this.item.projectId })
    },

    openWorkOrderModal () {
      this.$panel(WorkOrderModal, { projectCode: this.item.projectCode, status: 'Registered' }, 1000)
    },

    openInvoicePreviewModal () {
      this.$panel(InvoicePreviewModal, { projectId: this.item.projectId })
    },

    openFileViewerModal () {
      if (window.isElectron()) {
        setTimeout(() => {
          this.openNativeFileHandler()
          this.$emit('closePanel')
        }, 50)
      } else {
        this.$panel(FileViewerModal, { id: this.item.projectId })
      }
    },

    openNativeFileHandler () {
      if (window.isElectron()) {
        let error = false

        let result
        try {
          result = window.Bridge.openFileExplorer(this.item.projectCode)
        } catch (e) {
          error = true
        }

        if (result) {
          if (result.ok) {
            if (result.message) {
              this.$toast(result.message, 'info')
              // displayWebExplorer = false
            } else {
              error = true
            }
          } else {
            if (result.message) {
              this.$toast(result.message, 'error')
            } else {
              error = true
            }
          }
        }
        if (error) {
          this.$toast('Inget svar från applikationen', 'error')
        }
      }
    },

    pushToContactRoute () {
      this.$emit('closePanel')
      this.$router.push({ name: 'Contacts_Persons_Project', params: { projectId: this.item.projectId } })
    },

    pushToAddressRoute () {
      this.$emit('closePanel')
      this.$router.push({ name: 'Contacts_Addresses_Project', params: { projectId: this.item.projectId } })
    },

    pushToWorkOrders () {
      this.$store.state.workOrdersPerProject.all.defaultFilter.projectCode = this.item.projectCode
      this.$store.dispatch('workOrdersPerProject/resetFilter')
      this.$store.dispatch('workOrdersPerProject/getListData')

      this.$emit('closePanel')
      this.$router.push({ name: 'Project_WorkOrders', params: { projectCode: this.item.projectCode } })
    },

    pushToInvoices () {
      this.$emit('closePanel')
      this.$router.push({ name: 'Invoices_Project', params: { projectCode: this.item.projectCode } })
    }
    /* pushToProjectDetails () {
      this.$emit('closePanel')
      this.$router.push({ name: 'Project_Details', params: { projectId: this.item.projectId } })
    } */
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/ContextMenuModal.vue